'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.describeChargeAmount = exports.describeCard = exports.describeCardNumber = exports.describeFrequency = exports.describeCoupon = exports.calculateCouponDiscount = exports.dollarsToCents = exports.centsToDollars = exports.convertPriceUnits = undefined;

var _stringUtil = require('../utils/stringUtil');

var _currencyUtil = require('./currencyUtil');

var _paymentConstants = require('./paymentConstants');

var MONTHS_IN_YEAR = 12;

// Constants
// Util
var convertPriceUnits = exports.convertPriceUnits = function convertPriceUnits(price, priceUnit, toUnit) {
    if (priceUnit === _paymentConstants.PRICE_BILLING_UNITS.month && toUnit === _paymentConstants.PRICE_BILLING_UNITS.year) {
        return price * MONTHS_IN_YEAR;
    }

    if (priceUnit === _paymentConstants.PRICE_BILLING_UNITS.year && toUnit === _paymentConstants.PRICE_BILLING_UNITS.month) {
        return price / MONTHS_IN_YEAR;
    }

    return price;
};

var CENTS_IN_DOLLAR = 100;
var centsToDollars = exports.centsToDollars = function centsToDollars(cents) {
    var dollar = cents / CENTS_IN_DOLLAR;
    return Number.isInteger(dollar) ? dollar : dollar.toFixed(2);
};
var dollarsToCents = exports.dollarsToCents = function dollarsToCents(dollars) {
    return dollars * CENTS_IN_DOLLAR;
};

var calculateAmountOff = function calculateAmountOff(amountOff, price) {
    return price - amountOff;
};
var calculatePercentOff = function calculatePercentOff(percentOff, price) {
    return price - price * (percentOff / 100);
};

/**
 * Calculate price
 *
 * @param coupon The coupon:
 * { amount_off: Number (optional), percent_off: Number (optional), duration:[one of: 'forever', 'once', 'repeating'], duration_in_months: Number (exists if duration === 'repeating')] }
 * @param price The price to calculate coupon value on
 */
var calculateCouponDiscount = exports.calculateCouponDiscount = function calculateCouponDiscount(coupon, price) {
    if (!coupon) return price;
    if (coupon.amount_off) return calculateAmountOff(coupon.amount_off, price);
    if (coupon.percent_off) return calculatePercentOff(coupon.percent_off, price);
    return price;
};

var describeCouponAmount = function describeCouponAmount(_ref) {
    var amount_off = _ref.amount_off,
        percent_off = _ref.percent_off;
    return amount_off ? '$' + centsToDollars(amount_off) + ' off' : percent_off + '% off' // eslint-disable-line camelcase
    ;
};

var describeCouponDuration = function describeCouponDuration(_ref2) {
    var duration = _ref2.duration,
        duration_in_months = _ref2.duration_in_months;

    switch (duration) {
        case _paymentConstants.COUPON_DURATION.forever:
            return ' forever';
        case _paymentConstants.COUPON_DURATION.repeating:
            return ' for ' + duration_in_months + ' ' + (0, _stringUtil.pluralise)('month', duration_in_months); // eslint-disable-line camelcase
        case _paymentConstants.COUPON_DURATION.once:
        default:
            return '';
    }
};

/**
 * Describe a coupon
 *
 * @param coupon The coupon:
 * { amount_off: Number (optional), percent_off: Number (optional), duration:[one of: 'forever', 'once', 'repeating'], duration_in_months: Number (exists if duration === 'repeating')] }
 */
var describeCoupon = exports.describeCoupon = function describeCoupon(coupon) {
    return coupon ? '' + describeCouponAmount(coupon) + describeCouponDuration(coupon) : undefined;
};

var describeFrequency = exports.describeFrequency = function describeFrequency(duration) {
    switch (duration) {
        case _paymentConstants.PRICE_BILLING_UNITS.year:
            return 'annually';
        case _paymentConstants.PRICE_BILLING_UNITS.month:
        default:
            return duration + 'ly';
    }
};

var describeCardNumber = exports.describeCardNumber = function describeCardNumber(last4) {
    return '\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 ' + last4;
};

var describeCard = exports.describeCard = function describeCard(_ref3) {
    var last4 = _ref3.last4,
        brand = _ref3.brand;

    if (!last4 && !brand) return 'No card';

    return brand + ' (' + describeCardNumber(last4) + ')';
};

var describeChargeAmount = exports.describeChargeAmount = function describeChargeAmount(_ref4) {
    var currency = _ref4.currency,
        amount = _ref4.amount;
    return '' + (0, _currencyUtil.getCurrencySymbol)(currency) + centsToDollars(amount);
};


//////////////////
// WEBPACK FOOTER
// ./src/common/payment/paymentUtil.js
// module id = 244
// module chunks = 0